import React, { useState, useEffect } from 'react';
import { InputLabel, FormLabel, FormControl, FormControlLabel, Select, MenuItem, Box, TextField, Checkbox, IconButton,Typography, InputAdornment } from "@mui/material"
import CircleCheckedFilled from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import CircleUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import { FormikProps } from "formik";
import { finalSilenceOptions, promptLatencyOptions, promptTimeoutOptions } from '../../helpers/form.helper';
import { useDrop } from 'react-dnd'
import { useSelector } from 'react-redux';
import { useAppDispatch } from "../../store/hooks";
import { IPrompt } from "../../types/interfaces/prompt.interface";
import { addSelectedPrompts } from '../../store/resuders/prompt.reducer';
import { toggleAlert } from "../../store/resuders/app.reducer";    
import { getSelectedPrompts } from "../../store/selectors/prompt.selector";
import { useTranslation } from 'react-i18next';
import { set } from 'lodash';

export interface IProps {
    formik: FormikProps<any>;
    segmentName?: string;
    type?: string;
    language?: string;
}

export const ListenAnything = ({ formik }: IProps) => {
    // Access the formik values and helpers as needed
    const { values, handleChange } = formik;
    const selectedPrompts = useSelector(getSelectedPrompts);
    const [removePrompts, setRemovePrompts] = React.useState<string[]>([]);
    const dispatch = useAppDispatch();
    const [usePromptLibrary, setUsePromptLibrary] = useState(false);
    const { t } = useTranslation();
    const [prompts, setPrompts] = useState<IPrompt[]>(selectedPrompts);

    const addPromptFromLibrary = (item: any) => {
        const updatedPrompts = [...prompts, item];
        setPrompts(updatedPrompts);
        dispatch(addSelectedPrompts(updatedPrompts));
    }

    const [{ isOver }, drop] = useDrop(() => ({
        accept: 'ROWS',
        drop: addPromptFromLibrary,
        collect: (monitor: any) => ({
            isOver: !!monitor.isOver(),
        }),
    }), [prompts])

    const promptSelectionChanged = (seg: IPrompt) => (e: any) => {
        if (e.target.checked) {
            setRemovePrompts(removePrompts.concat(seg.id))
        } else {
            setRemovePrompts(removePrompts.filter(c => c !== seg.id))

        }
    }

    const handleSelectPromptLibrary = ()  => {
        setUsePromptLibrary(!usePromptLibrary)
        handleChange({ target: { name: 'selectPromptLibrary', value: !usePromptLibrary } });
    }

    const handleRemovePrompt = (libraryID: any, index: number) => {
            const updatedPrompts = prompts.filter((prompt, i) => i !== index);
            console.log('updatedPrompts', updatedPrompts);
            setPrompts(updatedPrompts);
            dispatch(addSelectedPrompts(updatedPrompts));
    };
    
     useEffect(() => {
            formik.setFieldValue('libraryItemIds', prompts?.map(p => ({ libraryID: p.libraryID })));
            console.log('libraryItemIds', formik.values.libraryItemIds);
        }, [prompts]);

    // Style property for textfield prompts
    const boldStyle = { fontWeight: 'bold' };
    return (
        <>
            <Box className='prompt-select' ref={usePromptLibrary? drop: null}>
                <FormControl sx={{ width: "100%" }}>
                {usePromptLibrary ? (
                        <>
                            {!prompts?.length ? (
                                <>
                            <InputLabel id="case-editor-prompt"></InputLabel>
                            <TextField
                                id="prompt"
                                name='prompt'
                                value={"Add Prompt from the Library"}
                                label={t("Prompt")}
                                onChange={handleChange}
                            />
                            </>) : (
                            <>
                            <TextField
                                id="prompts"
                                name="prompts"
                                inputProps={{
                                    style: boldStyle,
                                }}
                                value=""
                                label={t("Prompts")}
                                onChange={() => {}}
                                multiline
                                rows={prompts.length}
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" style={{ display: 'inline-table', flexDirection: 'column', alignItems: 'flex-start', width: '100%', overflow: 'auto', maxHeight: '150px' }}>
                                            {prompts.map( (prompt, index) => (
                                                <Box key={index} style={{ display: 'flex', alignItems: 'center', width: '100%',  flexWrap: 'wrap' }}>
                                                    <Typography style={{ whiteSpace: 'pre-wrap', flexGrow: 1 }}>
                                                        {`${prompt.libraryID} ${prompt.name}`}
                                                    </Typography>
                                                    <IconButton onClick={() => handleRemovePrompt(prompt.libraryID, index)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            </>
                            )}
                        </>
                    ) : (
                        <>
                            <InputLabel id="case-editor-prompt"></InputLabel>
                            <TextField
                                id="prompt"
                                name='prompt'
                                value={values.prompt}
                                label={t("Prompt")}
                                onChange={handleChange}
                            />
                        </>
                    )}
                </FormControl>
                <FormControl>
                    <FormControlLabel
                        name="case-select-prompt-library"
                        control={
                            <Checkbox
                                id='selectPromptLibrary'
                                name='selectPromptLibrary'
                                icon={<CircleUnchecked />}
                                checkedIcon={<CircleCheckedFilled />}
                                value={values?.selectPromptLibrary}
                                onChange={handleSelectPromptLibrary}
                            />
                        }
                        label="Select From the Prompt Library"
                        labelPlacement="end"
                    />
                </FormControl>
            </Box>

            <Box sx={{ display: 'flex' }}>
                {/* Left Side of Prompt Library */}
                <Box className='prompt-library-left' sx={{ width: '50%' }}>
                    <Box>
                        <div className="prompt-library-dropdowns">
                            <FormControl sx={{ width: "75%" }}>
                                <FormLabel htmlFor="case-editor-latency-min">{t('Prompt Latency Min')}:</FormLabel>
                            </FormControl>
                            <FormControl sx={{ width: "25%" }}>
                                <Select
                                    labelId="case-editor-latency-min"
                                    id="promptLatencyMin"
                                    name='promptLatencyMin'
                                    value={values?.promptLatencyMin}
                                    label={t("latency-min")}
                                    onChange={handleChange}
                                >
                                    {promptLatencyOptions.map(id => (
                                        <MenuItem value={id}>{id}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                    
                    <Box>
                        <div className="prompt-library-dropdowns">
                            <FormControl sx={{ width: "75%" }}>
                                <FormLabel htmlFor="case-editor-prompt-timeout">{t('Prompt Timeout')}:</FormLabel>
                            </FormControl>
                            <FormControl sx={{ width: "25%" }}>
                                <Select
                                    labelId="case-editor-prompt-timeout"
                                    id="stepTimeout"
                                    name='stepTimeout'
                                    value={values?.stepTimeout}
                                    label={t("prompt-timeout")}
                                    onChange={handleChange}
                                >
                                    {promptTimeoutOptions.map(id => (
                                        <MenuItem value={id}>{id}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                </Box>

                {/* Right Side of Prompt Library */}
                <Box className='prompt-library-right' sx={{ width: '50%' }}>
                    <Box>
                        <div className="prompt-library-dropdowns">
                            <FormControl sx={{ width: "75%" }}>
                                <FormLabel htmlFor="case-editor-latency-max">{t('Prompt Latency Max')}:</FormLabel>
                            </FormControl>
                            <FormControl sx={{ width: "25%" }}>
                                <Select
                                    labelId="case-editor-latency-max"
                                    id="promptLatencyMax"
                                    name='promptLatencyMax'
                                    value={values?.promptLatencyMax}
                                    label={t("latency-max")}
                                    onChange={handleChange}
                                >
                                    {promptLatencyOptions.map(id => (
                                        <MenuItem value={id}>{id}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                    <Box>
                        <div className="prompt-library-dropdowns">
                            <FormControl sx={{ width: "75%" }}>
                                <FormLabel htmlFor="case-editor-final-silence">{t('Final Silence')}:</FormLabel>
                            </FormControl>
                            <FormControl sx={{ width: "25%" }}>
                                <Select
                                    labelId="case-editor-final-silence"
                                    id="finalSilence"
                                    name='finalSilence'
                                    value={values?.finalSilence}
                                    label={t("final-silence")}
                                    onChange={handleChange}
                                >
                                    {finalSilenceOptions.map(id => (
                                        <MenuItem value={id}>{id}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                </Box>
               
            </Box>
        </>
    );
};
